import {getJSON} from 'jquery';
import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen, showSecondaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {Observable} from '~knockout/index';
import {globalConfig} from '../../../config/Config';
import {ILeaderboardEntry} from 'power-patrol';
import {playSound} from '../../../game/audio/AudioManager';


var template = require('./GameOverScreen.html');

class GameOverScreenComponent extends Screen
{
    score: Observable<number>;
    position: Observable<number>;
    gameOverMessage: Observable<string>;
    overrideVisibility: Observable<boolean>;

    /**
     * create observable properties to let app elements communicate
     */
    createBindings()
    {
        super.createBindings();

        this.score = getGameManager().score;
        this.gameOverMessage = getGameManager().gameOverMessage;
        this.position = ko.observable(0);
    }



    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'game-over');
    }


    /**
     * show the leaderboard
     */
    showLeaderboard = () =>
    {
        //  if the user has scored high enough to earn a place on the leaderboard, go to the submit screen

        if (this.position() <= 50)
        {
            showSecondaryScreen('leaderboard');
        }
        else
        {
            showPrimaryScreen('leaderboard');
        }
    };


    /**
     * call a function when we show
     */
    onShow()
    {
        //this.score(15000 + Math.round(Math.random() * 100));

        //  populate the screen with score and position data

        getJSON(globalConfig.leaderboardUrl + '/api/get-position/' + this.score(), (response: any) =>
        {
            //  if the user hasn't made it on to the leaderboard the response is

            if (typeof response.position === 'string')
            {
                return this.position(response.position);
            }

            this.position(response.position + 1);
        });

        //  animate the screen in

        var timeline: TimelineMax;

        timeline = new TimelineMax();

        timeline.fromTo('.pp-gameplay-game-over-overlay', 1, { opacity: 0 }, { opacity: 1, ease: Expo.easeOut });
        timeline.fromTo('.pp-overlay__modal__game-over', 1, { top: '-300%' }, { top: '50%', ease: Back.easeOut, easeParams: [0.8] }, 0.5);
        timeline.fromTo('.pp-overlay__game-over__zingy', 1, { bottom: '-600px' }, { bottom: '-40px', ease: Back.easeOut, easeParams: [0.9] }, 1);
        timeline.fromTo('.pp-overlay__game-over__next-btn', 1, { opacity: 0 }, { opacity: 1, ease: Expo.easeOut }, 0.5);

        //  play sound

        playSound('game-over');
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerGameOverScreenComponent()
{
    ko.components.register('pp-gameplay-game-over-overlay',
        {
            viewModel: () => { return new GameOverScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/game-over/GameOverScreen.ts